import React, { useContext, useMemo } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ReactTemplate } from '@bingads-webui-react/react-template';
import { setClarityScenario } from '@bingads-webui-universal/clarity';
import { PoliticalAdsDeclaration } from './political-ads-declaration';
import type { IUsePoliticalAdsLoggerProps } from '../types';
import { usePoliticalAdsDeclarationLogger } from '../hooks/use-political-ads-declaration-logger';

export const MAIN_PINTEREST_IMPORT_DECLARATION_TEMPLATE = _TL_('By selecting {{strong}}Sign in to Pinterest Ads{{/strong}}, I confirm that the campaigns associated with my account are {{em}}not{{/em}} intended for political advertising.');
export const MAIN_FILE_IMPORT_DECLARATION_TEMPLATE = _TL_('By selecting {{strong}}Continue{{/strong}}, I confirm that the campaigns associated with my account are {{em}}not{{/em}} intended for political advertising.');
export const MAIN_AMAZON_IMPORT_DECLARATION_TEMPLATE = _TL_('By selecting {{strong}}Sign in to Amazon Ads{{/strong}}, I confirm that the campaigns associated with my account are {{em}}not{{/em}} intended for political advertising.');
export const MAIN_META_IMPORT_DECLARATION_TEMPLATE = _TL_('By selecting {{strong}}Sign in with Meta{{/strong}}, I confirm that my Meta Ads political ad declaration is accurate. I understand that Microsoft Advertising will skip campaigns marked as political during import.');
export const MAIN_GOOGLE_IMPORT_SIGN_IN_DECLARATION_TEMPLATE = _TL_('By selecting {{strong}}Sign in with Google{{/strong}}, I confirm that my Google Ads political ad declaration is accurate. I understand that Microsoft Advertising will skip campaigns marked as political during import.');
export const MAIN_GOOGLE_IMPORT_CONTINUE_DECLARATION_TEMPLATE = _TL_('By selecting {{strong}}Continue{{/strong}}, I confirm that my Google Ads political ad declaration is accurate. I understand that Microsoft Advertising will skip campaigns marked as political during import.');
export const CHOOSE_ACCOUNTS_GOOGLE_IMPORT_DECLARATION_TEMPLATE = _TL_('By selecting {{strong}}Next{{/strong}}, I confirm that my Google Ads political ad declaration is accurate. I understand that Microsoft Advertising will skip campaigns marked as political during import.');
export const CHOOSE_ACCOUNTS_META_IMPORT_DECLARATION_TEMPLATE = _TL_('By selecting {{strong}}Next{{/strong}}, I confirm that my Meta Ads political ad declaration is accurate. I understand that Microsoft Advertising will skip campaigns marked as political during import.');

export interface ImportPoliticalAdsDeclarationProps extends IUsePoliticalAdsLoggerProps {
  onChange: (hasPoliticalAds: boolean) => void;
  declarationTemplate: string;
  disabled?: boolean;
}

export const ImportPoliticalAdsDeclaration = (props: ImportPoliticalAdsDeclarationProps) => {
  const {
    onChange,
    declarationTemplate,
    disabled,
    logger,
    task,
  } = props;

  const i18n = useContext(I18nContext);

  const model = useMemo(() => ({
    strong: (text: React.ReactNode) => <strong>{text}</strong>,
    em: (text: React.ReactNode) => <em>{text}</em>,
  }), []);

  const {
    logToggledSelection,
  } = usePoliticalAdsDeclarationLogger({
    task,
    logger,
  });

  const handleChange = (value: boolean) => {
    setClarityScenario('IsPoliticalAdsDeclarationToggled');
    onChange(value);
  };

  return (
    <PoliticalAdsDeclaration
      onChange={handleChange}
      title={i18n.getString(_TL_('Political advertising declaration'))}
      checkboxLabel={<ReactTemplate
        model={model}
        template={i18n.getString(declarationTemplate)}
      />}
      helpTopic="pop_BA_PoliticalAdvertisingDeclaration_Import"
      disabled={disabled}
      logToggledSelection={logToggledSelection}
    />
  );
};

ImportPoliticalAdsDeclaration.defaultProps = {
  disabled: false,
};
